Array.prototype.desc = function desc() {
    return this.sort((a, b) => (a === b ? 0 : a > b ? -1 : 1));
};
